import summaryReportsActionCreators from "Areas/SummaryReports/redux/actionCreators";
import summaryReportsRoutingKeys from "Areas/SummaryReports/routingKeys";
import { actionCreators as summaryReportEditorActionCreators } from "Areas/SummaryReports/summaryReportEditorPanel";
import { Permissions, security } from "Common/permissions";
import { routesAndPagesMap } from "Common/routingUtils";
import { connect } from "react-redux";
import SummaryReportWithPreviewImage from "./summaryReportWithPreviewImage";
const getSummaryReportDetailsHref = (summaryReportId) => routesAndPagesMap.getPath(summaryReportsRoutingKeys.SUMMARY_REPORT_DETAILS, summaryReportId);
const canEdit = security.isAllowed([Permissions.SummaryReportsEdit]);
const canDelete = security.isAllowed([Permissions.SummaryReportsDelete]);
const mapStateToProps = () => ({
    getSummaryReportDetailsHref,
    canEdit,
    canDelete
});
const mapDispatchToProps = (dispatch) => ({
    onOpenEditorPanel: (summaryReportId) => dispatch(summaryReportEditorActionCreators.setSummaryReportId(summaryReportId)),
    onDelete: (summaryReportId) => dispatch(summaryReportsActionCreators.deleteSummaryReport(summaryReportId))
});
export default connect(mapStateToProps, mapDispatchToProps)(SummaryReportWithPreviewImage);
